module.exports = "/static/images/opengraph.jpg";